<template>
  <div class="blog">
    <div class="title">{{ title }}</div>
    <div class="box f-b-c">
      <div class="item" v-for="item in list" :key="item.type">
        <div class="img">
          <oss-img :height="376" :src="item.img_url" alt="img" mType="mfit" />
        </div>
        <div v-if="item.type" class="type f-c-c ellipsis">{{ item.type }}</div>
        <el-link type="primary" class="title1 ellipsis2" :href="item.url" target="_blank">{{ item.title }}</el-link>
        <div class="foot f-b-c">
          <div class="date">{{ item.date }}</div>
          <el-link type="text" class="more" :href="item.url">Read more</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.blog {
  .box {
    max-width: 1420px;
    margin: 0 auto;
    padding: 0 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    margin-bottom: 56px;
    font-size: 36px;
    line-height: 48px;
    font-weight: 600;
    text-align: center;
    color: #303133;
  }
  .item {
    width: 24%;
    .img {
      width: 100%;
      height: 0;
      padding-bottom: 115%;
      margin-bottom: 12px;
      background-color: #F7F8FB;
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      >img {
        position: absolute;
        width: unset;
      }
    }
  }
  .type {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 20px;
    background-color: #F7F8FB;
    margin-bottom: 8px;
    color: #909399;
    max-width: 100%;
  }
  .title1 {
    color: #303133;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 17px;
    font-weight: 600;
    display: -webkit-box !important;
  }
  .title1:hover {
    color: #9AC331;
  }
  .date {
    color: #909399;
    font-size: 14px;
  }
  .more {
    color: #9AC331;
    font-size: 16px;
  }

  @media screen and (max-width: 1000px) {
    .title {
      margin-bottom: 28px;
      font-size: 20px;
      line-height: 28px;
    }
    .box {
      flex-wrap: wrap;
      .item {
        width: 48%;
        .img {
          margin-bottom: 4px;
        }
      }
      .type {
        height: 28px;
        padding: 0 12px;
        border-radius: 20px;
        background-color: #F7F8FB;
        margin-bottom: 4px;
        font-size: 13px;
      }
      .title1 {
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 2px;
      }
      .foot {
        flex-direction: column;
        align-items: flex-start;
        .date {
          font-size: 12px;
          line-height: 18px;
          margin-bottom: 8px;
        }
        .more {
          font-size: 13px;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
